import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useModal } from '@/components/modal/useModal';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useSummaryStockLevels } from '@/services/catalogue/stockLevels/useSummaryStockLevels';
import { StockLevelStatus, useStockLevelStatus } from '@/services/catalogue/useCustomerCatalogueService';
import { useNavigateAndValidate } from '@/services/catalogue/validation/catalogueHooks';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent } from 'react';
import { CustomerCatalogueContainer } from '../../../CustomerCatalogueContainer';
import BeginFilfillmentModal from '../../BeginFulfillmentModal';
import StockUserGuideButton from '../StockUserGuideButton';
import { SummaryStockLevelsTable } from './SummaryStockLevelsTable';

const SummaryStockLevelsContent: FunctionComponent = () => {
  const routePrefix = useCustomerRoutePrefix();
  const navigateAndValidate = useNavigateAndValidate();

  const breadcrumbs: NavPage[] = [
    {
      name: 'Stock Calculator',
      to: `${routePrefix}/stockCalculator`
    },
    {
      name: 'Stock Summary',
      to: ''
    }
  ];

  const stockLevels = useSummaryStockLevels();

  const modalProps = useModal();

  const status = useStockLevelStatus();
  const inReview = status !== StockLevelStatus.APPROVED;

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title={'Stock Calculator'} subtitle="Stock Summary" breadcrumbs={breadcrumbs}>
        <div className="flex gap-4">
          <StockUserGuideButton />
          <Button
            onClick={() => {
              navigateAndValidate(`${routePrefix}/advanced/generalStockLevels`);
            }}
            variant={ButtonVariant.Mono}
          >
            <SiChevronLeft className="text-xl" />
            <span>Back to Additional Stock Levels</span>
          </Button>
          <Button onClick={() => modalProps.open()} variant={ButtonVariant.Primary}>
            <span>Begin Fulfillment</span>
          </Button>
        </div>
      </CataloguePageHeader>
      <div className="overflow-y-auto px-6 py-8 space-y-5 flex-1">
        {stockLevels.length === 0 ? (
          <div>There are no selected standardised products to display.</div>
        ) : (
          <div className="space-y-5">
            {inReview && (
              <>
                <div className="text-xl font-semibold">Please review the following stock levels.</div>
              </>
            )}
            <SummaryStockLevelsTable stockLevels={stockLevels} />
            {inReview && (
              <>
                <div className="text-xl font-semibold pt-5">
                  If you're happy with these stock levels, please click Begin Fulfillment.
                </div>
                <Button onClick={() => modalProps.open()} variant={ButtonVariant.Primary}>
                  <span>Begin Fulfillment</span>
                </Button>
              </>
            )}
          </div>
        )}
      </div>
      {}
      <BeginFilfillmentModal {...modalProps} />
    </div>
  );
};

export const SummaryStockLevels: FunctionComponent = () => {
  return (
    <CustomerCatalogueContainer>
      <SummaryStockLevelsContent />
    </CustomerCatalogueContainer>
  );
};
